module.exports = __webpack_public_path__ + "img/auth-banner2.6cf2d047.webp";